// Select primitive — port of design/v3/SettingsPage.jsx:290-294 (search input row tone).
// Native <select>; 시안 inline select 구조 그대로 토큰화.

import type { CSSProperties, SelectHTMLAttributes } from 'react';

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps
  extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  disabled?: boolean;
  style?: CSSProperties;
}

export function Select({
  value,
  onChange,
  options,
  placeholder,
  disabled,
  style,
  ...rest
}: SelectProps) {
  return (
    <select
      {...rest}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={{
        width: '100%',
        minWidth: 0,
        minHeight: 'var(--control-min-h)',
        boxSizing: 'border-box',
        padding: 'var(--control-pad-y) var(--control-pad-x)',
        fontSize: 13,
        fontFamily: 'var(--font-sans)',
        color: value ? 'var(--fg-1)' : 'var(--fg-3)',
        background: disabled ? 'var(--bg-subtle)' : 'var(--bg-surface)',
        border: '1px solid var(--border-base)',
        borderRadius: 'var(--radius-sm)',
        outline: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        appearance: 'none',
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2378716C' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\")",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 10px center',
        paddingRight: 28,
        textOverflow: 'ellipsis',
        ...style,
      }}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
